import { jsx as _jsx } from "react/jsx-runtime";
import { createRichTextEntityNode, RichTextNodeType, } from '@dossierhq/core';
import { BlockWithAlignableContents } from '@lexical/react/LexicalBlockWithAlignableContents.js';
import { DecoratorBlockNode } from '@lexical/react/LexicalDecoratorBlockNode.js';
import { useContext } from 'react';
import { ReferenceFieldDisplay } from '../EntityDisplay/ReferenceFieldDisplay.js';
import { RichTextDisplayContext } from './RichTextDisplayContext.js';
/** @public */
export function $createPublishedEntityNode(reference) {
    return new PublishedEntityNode(reference);
}
/** @public */
export function $isPublishedEntityNode(node) {
    return node instanceof PublishedEntityNode;
}
function PublishedEntityComponent({ className, format, nodeKey, reference, }) {
    const { fieldSpec } = useContext(RichTextDisplayContext);
    return (_jsx(BlockWithAlignableContents, { className: className, format: format, nodeKey: nodeKey, children: _jsx(ReferenceFieldDisplay, { className: "rich-text-item-indentation", fieldSpec: fieldSpec, value: reference }) }));
}
export class PublishedEntityNode extends DecoratorBlockNode {
    __reference;
    static getType() {
        return RichTextNodeType.entity;
    }
    static clone(node) {
        return new PublishedEntityNode(node.__reference, node.__format, node.__key);
    }
    constructor(reference, format, key) {
        super(format, key);
        this.__reference = reference;
    }
    setReference(reference) {
        const self = this.getWritable();
        self.__reference = reference;
    }
    getReference() {
        const self = this.getLatest();
        return self.__reference;
    }
    static importJSON(serializedNode) {
        const node = $createPublishedEntityNode(serializedNode.reference);
        node.setFormat(serializedNode.format);
        return node;
    }
    exportJSON() {
        //TODO format
        return createRichTextEntityNode(this.__reference);
    }
    createDOM() {
        const div = document.createElement('div');
        div.style.display = 'contents';
        return div;
    }
    getTextContent() {
        return '\n';
    }
    decorate(_editor, config) {
        const embedBlockTheme = config.theme.embedBlock || {};
        const className = {
            base: embedBlockTheme.base || '',
            focus: embedBlockTheme.focus || '',
        };
        return (_jsx(PublishedEntityComponent, { className: className, reference: this.__reference, format: this.__format, nodeKey: this.__key }));
    }
}
//# sourceMappingURL=PublishedEntityNode.js.map